import { cachedGet } from "../cache";
import { API_ENDPOINTS } from "../endpoints";
import type {
  ApiResponse,
  Category,
  CategoryFilters,
  PaginatedApiResponse,
  Product,
  Profile,
  Service,
} from "../interface";

export const categoryService = {
  async getAll(params: CategoryFilters = {}) {
    return cachedGet<PaginatedApiResponse<Category>>(
      API_ENDPOINTS.categories.all,
      { params }
    );

  },

  async getBySlug(slug: string) {
    return cachedGet<ApiResponse<Category>>(
      API_ENDPOINTS.categories.detail(slug)
    );

  },

  async getProfiles(slug: string) {
    return cachedGet<ApiResponse<Profile[]>>(
      API_ENDPOINTS.categories.profiles(slug)
    );

  },

  async getServices(slug: string) {
    return cachedGet<ApiResponse<Service[]>>(
      API_ENDPOINTS.categories.services(slug)
    );

  },

  async getProducts(slug: string) {
    return cachedGet<ApiResponse<Product[]>>(
      API_ENDPOINTS.categories.products(slug)
    );

  },
};
